import {GlobalDictType} from '../global/global.types';
import {CaffType}       from './caff.types';

export const CaffTypeDict: GlobalDictType<CaffType> = {
	coffee_lg: {
		name : 'Large Coffee',
		icon : 'coffee',
		type : 'coffee_lg',
		colorTw: 'yellow'
	},
	coffee_sm: {
		name : 'Small Coffee',
		icon : 'mug-hot',
		type : 'coffee_sm',
		colorTw: 'yellow'
	},
	soda     : {
		name : 'Soda',
		icon : 'glass-whiskey',
		type : 'soda',
		colorTw: 'yellow'
	},
	tea      : {
		name : 'Tea',
		icon : 'leaf',
		type : 'tea',
		colorTw: 'yellow'
	}
};